// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"540":"9947614b","917":"46140d96"}[chunkId] + ".chunk.js";
};